import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
// import { yupResolver } from '@hookform/resolvers/yup';

/**
 * @typedef {import ('../../interfaces/services/ILogin.interface').ILoginForm} ILoginForm
 */
const defaultValues = {
  newPassword: '',
  confirmNewPassword: '',
};

const resolver = yupResolver(
  yup.object().shape({
    newPassword: yup
      .string()
      .required('Campo obligatorio')
      .matches(/[*.\-º#,]/, 'Faltan añadir caracteres especiales como *.-º#'),
    confirmNewPassword: yup.string().oneOf([yup.ref('newPassword'), null], 'Las contraseñas deben coincidir'),
  })
);

const validation = async (formData) => {
  const isValid = await yup
    .object()
    .shape({
      newPassword: yup
        .string()
        .required('Campo obligatorio')
        .matches(/[*.\-º#,]/, 'Faltan añadir caracteres especiales como *.-º#'),
      confirmNewPassword: yup.string().oneOf([yup.ref('newPassword'), null], 'Las contraseñas deben coincidir'),
    })
    .isValid(formData);
  return isValid;
};

export { defaultValues, resolver, validation };
